




















import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import MetricIcon from "@/components/Icons/MetricIcon.vue";
@Component({
  components: { MetricIcon }
})
export default class MetricHolder extends Vue {
  @Prop() private name!: string;
  @Prop() private value!: string;
  @Prop({ default: "" }) private active?: string;
  
  private isShowTooltip = false;
  
  private capitalize(s: string) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  private getTooltipText(name: string) {
    if(name=='Confidence') {
      return "Measures your confidence level through the words you use";
    } else if(name=='Conciseness') {
      return "Tells you if you're talking to the point, or going around the bush";
    } else if(name=='Clarity') {
      return ""
    } else if(name=='Energy') {
      return "Tells you if you're speaking in a boring monotone, or actually varying your energy";
    } else if(name=='Pace') {
      return "Measures how fast or slow you're speaking, as well as your variation throughout your recordings";
    } else if(name=='Fillers') {
      return 'Counts your "um", "uhs" and other filler words that make you sound less confident and prepared.';
    } else if(name=='Expression') {
      return "Shows you when you smiled and when you looked serious in your recording";
    }
  }
}
